const {store} = aofljs;
import mutations from './mutations';

let sdo = {
  namespace: 'homeFooter',
  alias: 'homeFooter',
  mutations: mutations
};

store.addState(sdo);



// WEBPACK FOOTER //
// ./home/en-US/js/home-footer/sdo/index.js